module.exports = __webpack_public_path__ + "img/a.dc09c73b.jpg";